import React, { useState } from 'react';
import { AdvisoryHeader } from '../components/advisory/AdvisoryHeader';
import { AdvisoryHero } from '../components/advisory/AdvisoryHero';
import { EmpathySection } from '../components/advisory/EmpathySection';
import { ServicesGrid } from '../components/advisory/ServicesGrid';
import { CaseStudies } from '../components/advisory/CaseStudies';
import { MeetTheExpert } from '../components/advisory/MeetTheExpert';
import { AdvisoryFAQ } from '../components/advisory/AdvisoryFAQ';
import { AdvisoryFinalCTA } from '../components/advisory/AdvisoryFinalCTA';
import { AdvisoryFooter } from '../components/advisory/AdvisoryFooter';
import { ContactForm } from '../components/ContactForm';
export function AdvisoryPage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openContactForm = () => {
    setIsContactFormOpen(true);
  };
  const closeContactForm = () => {
    setIsContactFormOpen(false);
  };
  return <div className="bg-white text-slate-900 min-h-screen w-full" data-id="element-638">
      <AdvisoryHeader openContactForm={openContactForm} data-id="element-639" />

      <main data-id="element-640">
        <AdvisoryHero openContactForm={openContactForm} data-id="element-641" />
        <EmpathySection data-id="element-642" />
        <ServicesGrid openContactForm={openContactForm} data-id="element-643" />
        <CaseStudies data-id="element-644" />
        <section id="about" data-id="element-645">
          <MeetTheExpert openContactForm={openContactForm} data-id="element-646" />
        </section>
        <section id="faq" data-id="element-647">
          <AdvisoryFAQ data-id="element-648" />
        </section>
        <AdvisoryFinalCTA openContactForm={openContactForm} data-id="element-649" />
      </main>

      <AdvisoryFooter data-id="element-650" />
      <ContactForm isOpen={isContactFormOpen} onClose={closeContactForm} data-id="element-651" />
    </div>;
}